



















import Vue from 'vue'

export default Vue.extend({
  name: 'BehaviorsLimitedSubForm',
  props: {
    triggerSendingData: {
      required: false,
      type: Boolean,
      default: false
    },
    entitlement: {
      required: false,
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      availableSince: null as Date|null,
      availableUntil: null as Date|null,
      available_since: '',
      available_until: ''
    }
  },
  watch: {
    triggerSendingData (val: boolean) {
      if (val) {
        let props:any = {}
        if (this.available_since || this.available_until) {
          if (this.available_since) {
            props['available_since'] = this.available_since
          }
          if (this.available_until) {
            props['available_until'] = this.available_until
          }
          this.$emit('onSetBehaviorsProps', props)
        } else {
          this.$emit('subFormError', "Date fields shouldn't be empty")
        }
      }
    },
    availableSince (val: any) {
      if (val) {
        this.available_since = val.toISOString()
      } else {
        this.available_since = ''
      }
    },
    availableUntil (val: any) {
      if (val) {
        this.available_until = val.toISOString()
      } else {
        this.available_until = ''
      }
    }
  },
  mounted () {
    this.setDataForEditEntitelment()
  },
  methods: {
    setDataForEditEntitelment () {
      this.availableSince = this.entitlement.available_since ? new Date(this.entitlement.available_since) : null as Date|null
      this.availableUntil = this.entitlement.available_until ? new Date(this.entitlement.available_until) : null as Date|null
    }
  }
})
